// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
const $Tag = tag => ({tag});
const New = /* #__PURE__ */ $Tag("New");
const Recommended = /* #__PURE__ */ $Tag("Recommended");
const SpecialOffer = /* #__PURE__ */ $Tag("SpecialOffer");
const Spicy = /* #__PURE__ */ $Tag("Spicy");
const VerySpicy = /* #__PURE__ */ $Tag("VerySpicy");
const SuperSpicy = /* #__PURE__ */ $Tag("SuperSpicy");
const Vegetarian = /* #__PURE__ */ $Tag("Vegetarian");
const GlutenFree = /* #__PURE__ */ $Tag("GlutenFree");
const SeaFood = /* #__PURE__ */ $Tag("SeaFood");
const LactoseFree = /* #__PURE__ */ $Tag("LactoseFree");
const Vegan = /* #__PURE__ */ $Tag("Vegan");
const Fit = /* #__PURE__ */ $Tag("Fit");
const PreventAutomaticCrossSelling = /* #__PURE__ */ $Tag("PreventAutomaticCrossSelling");
const eqTag = {
  eq: x => y => {
    if (x.tag === "New") { return y.tag === "New"; }
    if (x.tag === "Recommended") { return y.tag === "Recommended"; }
    if (x.tag === "SpecialOffer") { return y.tag === "SpecialOffer"; }
    if (x.tag === "Spicy") { return y.tag === "Spicy"; }
    if (x.tag === "VerySpicy") { return y.tag === "VerySpicy"; }
    if (x.tag === "SuperSpicy") { return y.tag === "SuperSpicy"; }
    if (x.tag === "Vegetarian") { return y.tag === "Vegetarian"; }
    if (x.tag === "GlutenFree") { return y.tag === "GlutenFree"; }
    if (x.tag === "SeaFood") { return y.tag === "SeaFood"; }
    if (x.tag === "LactoseFree") { return y.tag === "LactoseFree"; }
    if (x.tag === "Vegan") { return y.tag === "Vegan"; }
    if (x.tag === "Fit") { return y.tag === "Fit"; }
    if (x.tag === "PreventAutomaticCrossSelling") { return y.tag === "PreventAutomaticCrossSelling"; }
    return false;
  }
};
const ordTag = {
  compare: x => y => {
    if (x.tag === "New") {
      if (y.tag === "New") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "New") { return Data$dOrdering.GT; }
    if (x.tag === "Recommended") {
      if (y.tag === "Recommended") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Recommended") { return Data$dOrdering.GT; }
    if (x.tag === "SpecialOffer") {
      if (y.tag === "SpecialOffer") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "SpecialOffer") { return Data$dOrdering.GT; }
    if (x.tag === "Spicy") {
      if (y.tag === "Spicy") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Spicy") { return Data$dOrdering.GT; }
    if (x.tag === "VerySpicy") {
      if (y.tag === "VerySpicy") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "VerySpicy") { return Data$dOrdering.GT; }
    if (x.tag === "SuperSpicy") {
      if (y.tag === "SuperSpicy") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "SuperSpicy") { return Data$dOrdering.GT; }
    if (x.tag === "Vegetarian") {
      if (y.tag === "Vegetarian") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Vegetarian") { return Data$dOrdering.GT; }
    if (x.tag === "GlutenFree") {
      if (y.tag === "GlutenFree") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "GlutenFree") { return Data$dOrdering.GT; }
    if (x.tag === "SeaFood") {
      if (y.tag === "SeaFood") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "SeaFood") { return Data$dOrdering.GT; }
    if (x.tag === "LactoseFree") {
      if (y.tag === "LactoseFree") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "LactoseFree") { return Data$dOrdering.GT; }
    if (x.tag === "Vegan") {
      if (y.tag === "Vegan") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Vegan") { return Data$dOrdering.GT; }
    if (x.tag === "Fit") {
      if (y.tag === "Fit") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Fit") { return Data$dOrdering.GT; }
    if (x.tag === "PreventAutomaticCrossSelling") {
      if (y.tag === "PreventAutomaticCrossSelling") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqTag
};
const genericTag = {
  to: x => {
    if (x.tag === "Inl") { return New; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return Recommended; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return SpecialOffer; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return Spicy; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return VerySpicy; }
            if (x._1._1._1._1.tag === "Inr") {
              if (x._1._1._1._1._1.tag === "Inl") { return SuperSpicy; }
              if (x._1._1._1._1._1.tag === "Inr") {
                if (x._1._1._1._1._1._1.tag === "Inl") { return Vegetarian; }
                if (x._1._1._1._1._1._1.tag === "Inr") {
                  if (x._1._1._1._1._1._1._1.tag === "Inl") { return GlutenFree; }
                  if (x._1._1._1._1._1._1._1.tag === "Inr") {
                    if (x._1._1._1._1._1._1._1._1.tag === "Inl") { return SeaFood; }
                    if (x._1._1._1._1._1._1._1._1.tag === "Inr") {
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inl") { return LactoseFree; }
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return Vegan; }
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if (x._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return Fit; }
                          if (x._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") { return PreventAutomaticCrossSelling; }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "New") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Recommended") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "SpecialOffer") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "Spicy") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "VerySpicy") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
      );
    }
    if (x.tag === "SuperSpicy") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
        )
      );
    }
    if (x.tag === "Vegetarian") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
          )
        )
      );
    }
    if (x.tag === "GlutenFree") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
            )
          )
        )
      );
    }
    if (x.tag === "SeaFood") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
              )
            )
          )
        )
      );
    }
    if (x.tag === "LactoseFree") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "Vegan") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "Fit") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "PreventAutomaticCrossSelling") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    $runtime.fail();
  }
};
const showTag = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "New"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Recommended"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "SpecialOffer"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Spicy"});
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "VerySpicy"});
    const $5 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "SuperSpicy"});
    const $6 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Vegetarian"});
    const $7 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "GlutenFree"});
    const $8 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "SeaFood"});
    const $9 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "LactoseFree"});
    const $10 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Vegan"});
    const $11 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Fit"});
    const $12 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "PreventAutomaticCrossSelling"});
    return x => {
      const $13 = genericTag.from(x);
      if ($13.tag === "Inl") { return $0["genericShow'"]($13._1); }
      if ($13.tag === "Inr") {
        if ($13._1.tag === "Inl") { return $1["genericShow'"]($13._1._1); }
        if ($13._1.tag === "Inr") {
          if ($13._1._1.tag === "Inl") { return $2["genericShow'"]($13._1._1._1); }
          if ($13._1._1.tag === "Inr") {
            if ($13._1._1._1.tag === "Inl") { return $3["genericShow'"]($13._1._1._1._1); }
            if ($13._1._1._1.tag === "Inr") {
              if ($13._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($13._1._1._1._1._1); }
              if ($13._1._1._1._1.tag === "Inr") {
                if ($13._1._1._1._1._1.tag === "Inl") { return $5["genericShow'"]($13._1._1._1._1._1._1); }
                if ($13._1._1._1._1._1.tag === "Inr") {
                  if ($13._1._1._1._1._1._1.tag === "Inl") { return $6["genericShow'"]($13._1._1._1._1._1._1._1); }
                  if ($13._1._1._1._1._1._1.tag === "Inr") {
                    if ($13._1._1._1._1._1._1._1.tag === "Inl") { return $7["genericShow'"]($13._1._1._1._1._1._1._1._1); }
                    if ($13._1._1._1._1._1._1._1.tag === "Inr") {
                      if ($13._1._1._1._1._1._1._1._1.tag === "Inl") { return $8["genericShow'"]($13._1._1._1._1._1._1._1._1._1); }
                      if ($13._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if ($13._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $9["genericShow'"]($13._1._1._1._1._1._1._1._1._1._1); }
                        if ($13._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if ($13._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $10["genericShow'"]($13._1._1._1._1._1._1._1._1._1._1._1); }
                          if ($13._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if ($13._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $11["genericShow'"]($13._1._1._1._1._1._1._1._1._1._1._1._1); }
                            if ($13._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") { return $12["genericShow'"]($13._1._1._1._1._1._1._1._1._1._1._1._1); }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeTag = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericTag)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("New"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Recommended"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("SpecialOffer"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Spicy"), Data$dGeneric$dRep.NoArguments)]})(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("VerySpicy"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("SuperSpicy"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Vegetarian"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("GlutenFree"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("SeaFood"), Data$dGeneric$dRep.NoArguments)]})(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("LactoseFree"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Vegan"), Data$dGeneric$dRep.NoArguments)]})(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Fit"), Data$dGeneric$dRep.NoArguments)]
  })({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("PreventAutomaticCrossSelling"), Data$dGeneric$dRep.NoArguments)]})))))))))))))(Unscramble$dEnum.defaultEnumOptions)
};
const boundedTag = /* #__PURE__ */ (() => (
  {
    top: genericTag.to(Data$dGeneric$dRep.$Sum(
      "Inr",
      Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
                  )
                )
              )
            )
          )
        )
      )
    )),
    bottom: genericTag.to(Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)),
    Ord0: () => ordTag
  }
))();
const enumTag = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericTag)(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({"genericBottom'": Data$dGeneric$dRep.NoArguments}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  })),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericTag)(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({"genericBottom'": Data$dGeneric$dRep.NoArguments}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  }))({"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  })),
  Ord0: () => ordTag
};
const boundedEnumTag = /* #__PURE__ */ (() => (
  {
    cardinality: Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments)))))))))))))[
      "genericCardinality'"
    ],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericTag)(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments)))))))))))))),
    fromEnum: (() => {
      const $0 = Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments)))))))))))));
      return x => $0["genericFromEnum'"](genericTag.from(x));
    })(),
    Bounded0: () => boundedTag,
    Enum1: () => enumTag
  }
))();
const encodeTag = {
  encode: x => {
    const $0 = genericTag.from(x);
    if ($0.tag === "Inl") { return "New"; }
    if ($0.tag === "Inr") {
      if ($0._1.tag === "Inl") { return "Recommended"; }
      if ($0._1.tag === "Inr") {
        if ($0._1._1.tag === "Inl") { return "SpecialOffer"; }
        if ($0._1._1.tag === "Inr") {
          if ($0._1._1._1.tag === "Inl") { return "Spicy"; }
          if ($0._1._1._1.tag === "Inr") {
            if ($0._1._1._1._1.tag === "Inl") { return "VerySpicy"; }
            if ($0._1._1._1._1.tag === "Inr") {
              if ($0._1._1._1._1._1.tag === "Inl") { return "SuperSpicy"; }
              if ($0._1._1._1._1._1.tag === "Inr") {
                if ($0._1._1._1._1._1._1.tag === "Inl") { return "Vegetarian"; }
                if ($0._1._1._1._1._1._1.tag === "Inr") {
                  if ($0._1._1._1._1._1._1._1.tag === "Inl") { return "GlutenFree"; }
                  if ($0._1._1._1._1._1._1._1.tag === "Inr") {
                    if ($0._1._1._1._1._1._1._1._1.tag === "Inl") { return "SeaFood"; }
                    if ($0._1._1._1._1._1._1._1._1.tag === "Inr") {
                      if ($0._1._1._1._1._1._1._1._1._1.tag === "Inl") { return "LactoseFree"; }
                      if ($0._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                        const $1 = $0._1._1._1._1._1._1._1._1._1._1;
                        if ($1.tag === "Inl") { return "Vegan"; }
                        if ($1.tag === "Inr") {
                          if ($1._1.tag === "Inl") { return "Fit"; }
                          if ($1._1.tag === "Inr") { return "PreventAutomaticCrossSelling"; }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  }
};
const decodeTag = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericTag)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "New"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "Recommended"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "SpecialOffer"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({reflectSymbol: () => "Spicy"}))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "VerySpicy"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "SuperSpicy"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "Vegetarian"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "GlutenFree"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "SeaFood"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "LactoseFree"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({reflectSymbol: () => "Vegan"}))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "Fit"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({reflectSymbol: () => "PreventAutomaticCrossSelling"}))))))))))))))
};
export {
  $Tag,
  Fit,
  GlutenFree,
  LactoseFree,
  New,
  PreventAutomaticCrossSelling,
  Recommended,
  SeaFood,
  SpecialOffer,
  Spicy,
  SuperSpicy,
  Vegan,
  Vegetarian,
  VerySpicy,
  boundedEnumTag,
  boundedTag,
  decodeTag,
  encodeTag,
  enumTag,
  eqTag,
  genericTag,
  ordTag,
  showTag,
  unscrambleDecodeTag
};
